import { render, staticRenderFns } from "./imprTab.vue?vue&type=template&id=56eeee54"
import script from "./imprTab.vue?vue&type=script&lang=js"
export * from "./imprTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56eeee54')) {
      api.createRecord('56eeee54', component.options)
    } else {
      api.reload('56eeee54', component.options)
    }
    module.hot.accept("./imprTab.vue?vue&type=template&id=56eeee54", function () {
      api.rerender('56eeee54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/ibm/imprTab.vue"
export default component.exports